module.exports = __webpack_public_path__ + "static/img/bgxkskkzz_opcity.28b15a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bgxkskkzz_opcity.jpg
// module id = 8g5E
// module chunks = 1